<div id="sidebar-panel" class="mailbox sidebar left border-right scroll-y">
  <!-- ให้แสดงเฉพาะ mobile/ipad จนกว่าจะมี design การเปิด/ปิด sidebar ของ pc -->
  <div class="sidemenucontainer">
    <div>
      <button *ngIf="!isDesktop" title="Menu" id="sidebar-toggle-btn" class="btn btn-link menu-btn sq-btn rounded-0"
      type="button" (click)="toggleSidebar()">
      <span class="fa fa-bars icon-grey font-20"></span>
      </button>
      <a id="promptpost-logo" title="Home" class="navbar-logo" [routerLink]="['/dashboard']">
        <img class="logo_image my-2 mt-3 ml-3" src="assets/img/logo-promptpost.png" width="119" alt=""
          [routerLink]="['/dashboard']">
      </a>
    
      <ul class="nav flex-column mt-3" id="sidebar-menu" >
        <div *ngIf="!isLoading" style="height: 640px;overflow-y:scroll">
          <ng-container *ngFor="let module of modulesConfig; index as i;">
            <!-- new -->
            <ng-container *ngIf="module.submenu.length != '0'">
              <li class="nav-item" [class.show]="showMenu == module.name">
                <a title="{{'MENU.'+module.name | translate}}" id="sidebar-menu-{{module.name}}" [routerLink]="[]" class="menudropdown nav-link icon-pointer pb-0 d-flex align-items-center"
                  (click)="addExpandClass(module.name)" target="_self">
                  <img src="assets/img/{{module.imagePath}}" *ngIf="module.name" width="40" alt="">&nbsp;{{'MENU.' +module.name | translate}}
                  <div class="d-flex align-items-center pl-2">
                    <i class="arrow fa fa-angle-down"></i>
                  </div>              
                </a>
                <ul class="nav flex-column nav-second-level" [class.d-block]="showMenu == module.name">
                  <li *ngFor="let submenu of module.submenu;" class="nav-item">
                    <a title="{{'MENU.'+ submenu.name | translate}}" id="sidebar-sub-menu-{{submenu.id}}" (click)="onActionSubMenu(module, submenu.url)" [routerLinkActive]="['active']"
                      class="nav-link pl-3 icon-pointer">
                      <!-- <img src="assets/img/{{submenu.name}}.png" *ngIf="submenu.name" width="40" alt=""> -->
                      &nbsp;{{'MENU.'+submenu.name | translate}}
                      <span class="float-right mr-3" *ngIf="submenu.id == 1">
                        {{countInboxUnread}}
                      </span>
                      <span class="float-right mr-3" *ngIf="submenu.id == 3">
                        {{countDrafts}}
                      </span>
                    </a>
                  </li>
                </ul>
              </li>
            </ng-container>
            <ng-container *ngIf="module.submenu.length == '0'">
              <li *ngxPermissionsOnly="module.permissions" class="nav-item" [class.show]="showMenu == module.id">
                <a title="{{'MENU.'+module.name | translate}}" id="sidebar-menu-{{module.code}}"
                  class="menudropdown nav-link icon-pointer pb-0" (click)="onAction(module)" target="_self">
                  <img src="assets/img/{{module.imagePath}}" width="40" alt="">
                  &nbsp;{{'MENU.'+module.name | translate}}
                </a>
              </li>
            </ng-container>
           
          </ng-container>
        
    
        <ng-container *ngIf="imenus.length > 0;">
          <ng-container *ngFor="let menu of imenus;">
            <ng-container *ngIf="menu.submenu.length != '0'">
              <li class="nav-item" [class.show]="showMenu == menu.id">
                <a title="{{'MENU.'+menu.name | translate}}" id="sidebar-menu-{{menu.id}}" [routerLink]="[]" class="menudropdown nav-link icon-pointer pb-0 d-flex align-items-center"
                  (click)="addExpandClass(menu.id)" target="_self">
                  <img src="assets/img/{{menu.name}}.png" *ngIf="menu.name" width="40" alt="">&nbsp;{{'MENU.' +menu.name | translate}}
                  <div class="d-flex align-items-center pl-2">
                    <i class="arrow fa fa-angle-down"></i>
                  </div>              
                </a>
                <ul class="nav flex-column nav-second-level" [class.d-block]="showMenu == menu.id">
                  <li *ngFor="let submenu of menu.submenu;" class="nav-item">
                    <a title="{{'MENU.'+ submenu.name | translate}}" id="sidebar-sub-menu-{{submenu.id}}" routerLink="{{submenu.url}}" [routerLinkActive]="['active']"
                      class="nav-link pl-3 icon-pointer">
                      <!-- <img src="assets/img/{{submenu.name}}.png" *ngIf="submenu.name" width="40" alt=""> -->
                      &nbsp;{{'MENU.'+submenu.name | translate}}</a>
                  </li>
                </ul>
              </li>
            </ng-container> 
            <ng-container *ngIf="menu.submenu.length == '0'">
              <li class="sidebar-menu nav-item">
                <a id="sidebar-menu-{{menu.id}}" routerLink="{{menu.url}}" (click)="addExpandClass(menu.id)"
                  [routerLinkActive]="['active']" target="_self">
                  <img src="assets/img/{{menu.name}}.png"  width="40" alt="">&nbsp;{{'MENU.' + menu.name | translate}}
                </a>
              </li>
            </ng-container>
          </ng-container>
        </ng-container>
      </div>
    
      <div *ngIf="isLoading" class="d-flex justify-content-center">
        <div class="text-center mt-3 mb-1 d-flex align-items-center">
          <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
          <strong class="p-2">{{'Menu is loading' | translate}}...</strong>
        </div>
      </div>
    
        <!-- test get menu from module -->
        <!-- <ng-container *ngFor="let module of modulesConfig; index as i;">
          <div *ngxPermissionsOnly="module.permissions" class="parent card bg-white module-item"
            title="{{ module.name }}" (click)="onAction(module)">
            <img src="assets/img/{{ module.imagePath }}" height="100" class="mt-3" alt="{{ module.name }}">
            <h6 class="menu-name">{{ module.name }}</h6> 
          </div>
        </ng-container> -->
        <!--  -->
      </ul>
      <div class="row ml-2 mt-3" *ngIf="!storageLoading && storageUsageInfo && oncheckPermission(permissionManageDocument) ">
        <div class="col-12">
          <span class="text-dark">{{'DIGITALMAILBOX.Storage' | translate}}</span> 
        </div>
        <div class="col-12 mb-2">
          <span class="text-muted">{{'DIGITALMAILBOX.StorageUsage' | translate:({value: storageSize | byteFormat, max: storageUsageInfo.bucketSizeInBytes | byteFormat})}}</span> 
        </div>
        <div class="col-8 mt-1">
          <progressbar class="" [max]="storageUsageInfo.bucketSizeInBytes" [value]="storageUsageInfo.usageInBytes" 
          type="{{storageUsageType}}" [striped]="true" 
          [animate]="true">
          <!-- {{(storageUsagePercent >= 100)? 'Full':storageUsagePercent + '%'}} -->
          </progressbar>       
        </div> 
        <div class="col-4 text-muted">{{(storageUsagePercent >= 100)? 'Full':storageUsagePercent + '%'}} </div> 
      </div> 
      <div class="row ml-2 mt-3" *ngIf="!storageLoading && !storageUsageInfo">
        <div class="col-12">
          <span class="text-dark">{{'DIGITALMAILBOX.Storage' | translate}}</span> 
        </div>
        <div class="col-12 mb-2">
          <span class="text-muted">{{'DIGITALMAILBOX.StorageUsage' | translate:({value: storageSize | byteFormat, max: 524288000 | byteFormat})}}</span> 
        </div>
        <div class="col-8 mt-1">
          <progressbar class="" [max]="524288000" [value]="storageSize" 
          type="{{storageUsageType}}" [striped]="true" 
          [animate]="true">
          <!-- {{(storageUsagePercent >= 100)? 'Full':storageUsagePercent + '%'}} -->
          </progressbar>       
        </div> 
        <div class="col-4 text-muted">{{(storageUsagePercent >= 100)? 'Full':storageUsagePercent + '%'}} </div> 
      </div> 
      <div *ngIf="storageLoading" class="d-flex justify-content-center">
        <div class="text-center mt-3 mb-1 d-flex align-items-center">
          <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
          <strong class="p-2">{{'Storage is loading' | translate}}...</strong>
        </div>
      </div>
    </div>
    
  
  
    <div class="align-bottom mt-3" style="margin-bottom: 75px;">
      <div class="text-center">
        <div class="btn-group mb-3" id="btn-translate">
          <button id="btn-translate-thai" class="btn-lang btn-left" (click)="changeLanguage('TH')"
            [ngClass]="{ 'active': lang == 'TH' }">TH</button>
          <button id="btn-translate-eng" class="btn-lang btn-right" (click)="changeLanguage('EN')"
            [ngClass]="{ 'active': lang == 'EN' }">EN</button>
        </div>
      </div>
      
      <div class="fixed-buttom">
        <hr class="mt-0">
        <div class="d-block" dropdown>
          <div class="dropdown" dropdownToggle>
            <div class="col " >
              <div class="float-left text-dark mb-3">
                <figure class="avatar40 rounded-circle z3" *ngIf="profileImage">
                  <img src="data:image/png;base64,{{profileImage}}" height="40" width="40" alt="">
                </figure>
                <img *ngIf="!profileImage" src="assets/img/digital-mailbox-avatar.png" height="40" width="40" alt=""
                  onerror="this.onerror=null;this.src='assets/img/avatar.png'">
                <div class="h5 d-inline-block pl-2">
                  <span>{{ currentUser.username | limitTo:"15" }}</span>
                </div>
              </div>    
              <span class="fa fa-2x fa-angle-right float-right text-muted icon-pointer"></span>
            </div>
            <div class="dropdown-menu dropdown-menu-right dropdown-top-right" *dropdownMenu>
              <a title="Profile" class="dropdown-item" (click)="profile()"><i class="fa fa-user-o mr-2 p-1" aria-hidden="true"></i>{{'PROFILE.Profile' | translate}}</a>
              <a title="Consent" class="dropdown-item" (click)="consent()"><i class="fa fa-check-square-o mr-2 p-1" aria-hidden="true"></i>{{'PROFILE.Consent' | translate}}</a>
              <a title="Dsmr" class="dropdown-item" (click)="dsrmClick()"><i class="fa fa-file-text-o mr-2 p-1" aria-hidden="true"></i>{{'PROFILE.Dsrm' | translate}}</a>
              <a title="Request KYC Code" class="dropdown-item" (click)="requestKYCCode()"><i class="fa fa-id-badge mr-2 p-1" aria-hidden="true"></i>{{'PROFILE.Request KYC Code' | translate}}</a>            
              <a title="Request KYC History" class="dropdown-item" (click)="requestKYCHistory()"><i class="fa fa-history mr-2 p-1" aria-hidden="true"></i>{{'PROFILE.Request KYC History' | translate}}</a>            
              <a title="Change Password" class="dropdown-item" (click)="changePassword()"><i class="fa fa-unlock-alt mr-2 p-1" aria-hidden="true"></i>{{'PROFILE.Change Password' | translate}}</a>
              <a title="Logout" class="dropdown-item" (click)="logout()"><i class="fa fa-power-off mr-2 p-1" aria-hidden="true"></i>{{'PROFILE.Logout' | translate}}</a>     
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>  
</div>

<app-loader [(name)]="spinnerName"></app-loader>